import { setInternalServerError } from '../shared/scripts';
import Request from './common/Request';

class QuartzApi {
    static initializeQuartzEditor() {
        return Request.get('/api/quartz/initialize');
    }

    static getNewTriggersId(count) {
        return Request.get('/api/quartz/get-new-trigger-id/' + count);
    }

    static runJob(jobName, tenants) {
        return Request.get('/api/quartz/runJob/' + jobName + '/' + tenants);
    }

    static async save(changes) {
        try {
            const response = await fetch('/api/quartz/save', {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(changes)
            });
            const contentType = response.headers.get("content-type");
            if (response.status === 200 && contentType.indexOf("text/plain") !== -1) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const timeStr = new Date().getTime().toString();
                const fileName = 'QuarzDbScripts.' + timeStr + '.sql';
                a.download = fileName;
                a.innerText = fileName;

                return { ok: true, fileHtml: a.outerHTML };
            }
            else if (response.status === 200 && contentType.indexOf("application/json") !== -1) {
                return response.json();
            }
            else {
                return { error: "Failed to save quartz configuration. Reason - unexpected error." }
            }
        } catch (error) {
            setInternalServerError(error);
        }
    }
}

export default QuartzApi;